import { render, staticRenderFns } from "./CallItem.vue?vue&type=template&id=26929944&scoped=true"
import script from "./CallItem.vue?vue&type=script&lang=js"
export * from "./CallItem.vue?vue&type=script&lang=js"
import style0 from "./CallItem.vue?vue&type=style&index=0&id=26929944&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26929944",
  null
  
)

export default component.exports